import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material';
import styles from './unlockSsnDialog.module.css';
import { Input } from 'antd';
import SsnKeyIcon from '../../../Components/Icons/ssnKey';
import { IS_SSN_UNLOCKED_COLOR } from '../../../Components/tableComponent/getTableColumn/ChildComponents/ssnLock/ssnLockColor.constant';

interface UnlockSsnDialogProps {
    open: boolean;
    onClose: () => void;
    onUnlock: (remarks: string | null) => Promise<void>;
}

export const UnlockSsnDialog = (props: UnlockSsnDialogProps) => {
    const { open, onClose, onUnlock } = props;
    const [remarks, setRemarks] = useState<string | null>(null);

    const handleRemarksChange = (value: string) => {
        setRemarks(value);
    }

    const handleUnlock = async () => {
        await onUnlock(remarks);
    }

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            title={null}
            closable={false}
            centered={true}
            width={600}
        >
            <Box className={styles.modalContent}>
                <Box className={styles.modalIconCtn}>
                    <SsnKeyIcon fillColor={IS_SSN_UNLOCKED_COLOR} width={42} height={42} />
                </Box>
                <Box className={styles.modalTitleCtn}>
                    <p className={styles.modalTitle}>Confirm Identity Unlock</p>
                    <p className={styles.modalDescription}>You are about to unlock the identity (SSN, Email, and Phone) for this rejected application. Once unlocked, these identifiers will be available to use again for a new application.</p>
                    <p className={styles.modalDescription}>Please confirm that you have reviewed the application details before proceeding.</p>
                </Box>
                <Box className={styles.reasonContainer}>
                    <p className={styles.reasonText}>Reason for Unlocking <span className={styles.optionalText}>(Optional)</span></p>
                    <Input placeholder="Enter Reason" onChange={(e) => handleRemarksChange(e.target.value)} classNames={{input: styles.textInput}} className={styles.reasonInput} />
                </Box>
                <Box className={styles.modalButtonCtn}>
                        <Button className={`${styles.modalButton} ${styles.modalButtonCancel}`} onClick={onClose}>Cancel</Button>
                        <Button className={`${styles.modalButton} ${styles.modalButtonUnlock}`} onClick={handleUnlock}>Unlock Identity</Button>
                </Box>
            </Box>
        </Modal>
    )
}
